import React from 'react';
import styled from 'styled-components';

import type { IPanel } from './types';

import { otherColors } from '@/styles/colors';
import { sizing } from '@/styles/theme';

const Panel = (props: IPanel): React.ReactElement => (
  <Container className={`w-100 bg-white ${props.className}`}>{props.children}</Container>
);

export { Panel };

const Container = styled.div`
  border-color: ${otherColors.border.default};
  padding: ${sizing.padding.panelY} ${sizing.padding.panelX};
`;
